import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { t } from 'i18next';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { getLocalStorageMenuItem } from '../utility';

const SaveCustomerNameDialog = ({openSaveNameDialogVal, customerName, setCustomerNameVal, handleSaveCustomerName}) => {

    const saveCustomerName = () => {
        handleSaveCustomerName();
    };

    return (

        <Dialog className="alignByLang" open={openSaveNameDialogVal} fullWidth maxWidth="sm">
            <DialogTitle className="head-font">{t("Enter Your Name")}</DialogTitle>
            <DialogContent>
                <TextField
                    className="sub-font"
                    label={<span className="sub-font">{t("Name")}</span>}
                    variant="outlined"
                    fullWidth
                    value={customerName}
                    onChange={(e) => setCustomerNameVal(e.target.value)}
                    style={{ marginTop: "20px" }}
                    sx={{
                        ".MuiInputBase-input": {
                            fontFamily:
                                getLocalStorageMenuItem("lang") === "ar" ||
                                    getLocalStorageMenuItem("lang") === "fa"
                                    ? "Almarai"
                                    : "Roboto",
                        }
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button className="head-font" onClick={saveCustomerName} color="primary">
                    {t("save")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SaveCustomerNameDialog;